<template>
	<div>
		<DataInputMenuAbsoluteMenuWrapper v-model="showMenuFlag" v-bind="absoluteMenuProps">
			<DataInputMenu
				:localValue="localValue"
				:tab.sync="localTab"
				:param="param"
				:fieldParams="items"
				:errorMessage="retrievalErrorMessage"
				:allowMultipleSelection="allowMultipleSelection"
				:tabItems="tabItems"
				:curTabCode="curTabCode"
				:hasMoreData="hasMoreData"
				:loading="loading"
				:showMenuFlag="showMenuFlag"
				:valuesTypes="allowedValuesTypes"
				@close="showMenuFlag = false"
				v-on="localListeners"
				ref="data_input_menu"
				@re-calc-menu-position="reCalcMenuPosition"
				:didOpenBySlash="didOpenBySlash"
				:isBottomToTopLayout="isBottomToTopLayout"
				@load-more="() => endIntersect(null, null, true)"
				:listButtonText="listButtonText"
				:listButtonBillingFeatureId="listButtonBillingFeatureId"
				:showItemButtonFunc="showItemButtonFunc"
				@list-btn-clicked="$emit('list-btn-clicked')"
			>
			</DataInputMenu>
		</DataInputMenuAbsoluteMenuWrapper>
	</div>
</template>

<script>
import DataInputMenuMixin from './mixins/DataInputMenuMixin';
import DataInputMenu from '../../../DataInput/DataInputMenu/DataInputMenu';
import { DATA_INPUT_MENU_ALLOWED_VALUES } from '../../../DataInput/DataInputMenu/helpers/data-input-menu.const';
export default {
	name: 'StringDataInputMenu',
	mixins: [DataInputMenuMixin],
	props: {
		listButtonText: { type: String },
		showItemButtonFunc: { type: Function },
		listButtonBillingFeatureId: { type: String },
	},
	computed: {
		hasMoreData() {
			return this.dataInputMenuProps.hasMoreData;
		},
		loading() {
			return this.dataInputMenuProps.loading;
		},
		curTabCode() {
			return this.dataInputMenuProps.curTabCode;
		},
		items() {
			return this.dataInputMenuProps.items;
		},
		allowedValuesTypes() {
			return [DATA_INPUT_MENU_ALLOWED_VALUES.ITEM_DATA];
		},
		retrievalErrorMessage() {
			return this.dataInputMenuProps.retrievalErrorMessage;
		},
		localListeners() {
			return { ...this.$listeners, ...this.inputMenuListeners };
		},
	},
	components: {
		DataInputMenu,
	},
	methods: {
		endIntersect(...args) {
			this.$emit('end-intersect', ...args);
		},
	},
};
</script>
<style lang="scss"></style>
